import axios from "axios"

function fetchChatKey(params, success = null, error = null) {
  axios
    .get("/zapdoc/api/llm/chats/key", {
      params: params
    })
    .then((response) => {
      if (success) {
        success(response.data)
      }
    })
    .catch((err) => {
      if (error) {
        error(err)
      } else {
        alert(err)
      }
    })
}

function fetchChatDocIds(params, success = null, error = null) {
  axios
    .get("/zapdoc/api/llm/chats/doc_ids", {
      params: params
    })
    .then((response) => {
      if (success) {
        success(response.data)
      }
    })
    .catch((err) => {
      if (error) {
        error(err)
      } else {
        alert(err)
      }
    })
}

function fetchMessages(params, success = null, error = null) {
  axios
    .get(`/zapdoc/api/llm/chats/${params.key}/messages`, {
      params: params
    })
    .then((response) => {
      if (success) {
        success(response.data)
      }
    })
    .catch((err) => {
      if (error) {
        error(err)
      } else {
        alert(err)
      }
    })
}

function createMessage(params, success = null, error = null) {
  axios
    .post(`/zapdoc/api/llm/chats/${params.key}/message`, params)
    .then((response) => {
      if (success) {
        success(response.data)
      }
    })
    .catch((err) => {
      if (error) {
        error(err)
      } else {
        alert(err)
      }
    })
}

function deleteChat(params, success = null, error = null) {
  axios
    .delete(`/zapdoc/api/llm/chats/${params.key}`, params)
    .then((response) => {
      if (success) {
        success(response.data)
      }
    })
    .catch((err) => {
      if (error) {
        error(err)
      } else {
        alert(err)
      }
    })
}

export default {
  fetchChatKey,
  fetchChatDocIds,
  fetchMessages,
  createMessage,
  deleteChat
}
